import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Formik } from "formik";
import * as Yup from "yup";
import AlertComponent from "../components/AlertComponent";
import {
  deleteCamera,
  editCamera,
  postCamera,
} from "../redux/action/cameraAction";
import ModalComponent from "../components/ModalComponent";
import { openForm } from "../redux/slice/cameraSlice";
import { SelectInput } from "../components/InputComponent";
import { getSitesList } from "../redux/action/sitesAction";

const FormCamera = ({ param }) => {
  const { idCamera, dataByIdCamera, isOpenForm, state } = useSelector( (state) => state.camera );
  const { dataSitesList } = useSelector( (state) => state.sites );
  const dispatch = useDispatch();
  const [siteId, setSite] = useState('')
  const [optionSites, setOptionSites] = useState([])

  const initialValues = {
    name: idCamera === '' ? '' : dataByIdCamera.name,
    brand: idCamera === '' ? '' : dataByIdCamera.brand,
    type: idCamera === '' ? '' : dataByIdCamera.type,
    location: idCamera === '' ? '' : dataByIdCamera.location,
    latitude: idCamera === '' ? '' : dataByIdCamera.latitude,
    longitude: idCamera === '' ? '' : dataByIdCamera.longitude,
    alt: idCamera === '' ? '' : dataByIdCamera.alt,
    ip: idCamera === '' ? '' : dataByIdCamera.ip,
    user: idCamera === '' ? '' : dataByIdCamera.user,
    password: idCamera === '' ? '' : dataByIdCamera.password,
    url: idCamera === '' ? '' : dataByIdCamera.url,
    mac: idCamera === '' ? '' : dataByIdCamera.mac,
    serialNo: idCamera === '' ? '' : dataByIdCamera.serialNo,
    siteId: idCamera === "" ? "" : dataByIdCamera.siteId,
  };
  const validationSchema = Yup.object().shape({
    // name: Yup.string().required("Name is required!"),
    // brand: Yup.string().required("Brand is required!"),
    // type: Yup.string().required("Type is required!"),
    // location: Yup.string().required("Lokasi Kamera is required!"),
    // siteId: Yup.string().required("Lokasi JPO is required!"),
    // latitude: Yup.string().required("Latitude is required!"),
    // longitude: Yup.string().required("Longitude is required!"),
    // alt: Yup.string().required("Alt is required!"),
    // ip: Yup.string().required("IP is required!"),
    // user: Yup.string().required("User is required!"),
    // password: Yup.string().required("Password is required!"),
    // url: Yup.string().required("Url is required!"),
    // mac: Yup.string().required("Mac is required!"),
    // serialNo: Yup.string().required("Serial No is required!"),
  });
  const resetOption = () =>{
    setSite('')
  }

  const handleFormSubmit = async (values) => {
    if (state === "add") {
      param.data = values;
      // console.log(param.data);
      dispatch(postCamera(param));
      resetOption()
    } else if (state === "edit") {
      param.data = values;
      param.id = idCamera;
      dispatch(editCamera(param));
      resetOption()
    } else {
      param.id = idCamera;
      dispatch(deleteCamera(param));
      resetOption()
    }
  };
  
  const newSites = () => {
    // console.log(dataSupervisor)
    let arr = [{ name: '- PILIH LOKASI -', id: '' }]
    dataSitesList.map((row, index) => {
      arr.push({ name: row.siteName, id: row.siteId })
    })
    setOptionSites(arr)
    
  }
  useEffect(() => {
    newSites()
  }, [])
  useEffect(() => {
    if (dataSitesList.length > 0) {
      newSites()
    }
  }, [dataSitesList])

  useEffect(() => {
    dispatch(getSitesList(param));
  }, []);

  return state === "delete" ? (
    <AlertComponent
      show={isOpenForm}
      close={() => dispatch(openForm({ open: false, state: "close" }))}
      action={() => handleFormSubmit()}
    />
  ) : (
    <ModalComponent
      title={state === "add" ? "TAMBAH DATA CAMERA" : "EDIT DATA CAMERA"}
      show={isOpenForm}
      close={() => dispatch(openForm({ open: false, type: "close" }))}
      idForm="camera-form"
    >
      <Formik
        onSubmit={handleFormSubmit}
        initialValues={initialValues}
        validationSchema={validationSchema}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
        }) => (
          <form onSubmit={handleSubmit} id="camera-form">
            <div className="row align-items-center" style={{ color: "white" }}>
              <div className="form-group row mb-3">
                <label
                  htmlFor="staticEmail"
                  className="col-sm-2 col-form-label"
                >
                  Nama Kamera
                </label>
                <div className="col-sm-10" style={{ paddingBottom: "10px" }}>
                  <input
                    onChange={handleChange}
                    type="text"
                    name="name"
                    id="name"
                    className="form-control"
                    value={values.name}
                    validation={''}
                    props={{
                      onBlur: handleBlur,
                    }}
                  />
                  {touched.name && errors.name && (
                    <span style={{ color: "white" }}>{errors.name}</span>
                  )}
                </div>

                <label
                  htmlFor="staticEmail"
                  className="col-sm-2 col-form-label"
                >
                  Merek Kamera
                </label>
                <div className="col-sm-10" style={{ paddingBottom: "10px" }}>
                  <input
                    onChange={handleChange}
                    type="text"
                    name="brand"
                    id="brand"
                    className="form-control"
                    value={values.brand}
                    validation={''}
                    // validation={{
                    //   touched: touched.brand,
                    //   errors: errors.brand,
                    // }}
                    props={{
                      onBlur: handleBlur,
                    }}
                  />
                  {/* {touched.brand && errors.brand && (
                    <span style={{ color: "white" }}>{errors.brand}</span>
                  )} */}
                </div>

                <label
                  htmlFor="staticEmail"
                  className="col-sm-2 col-form-label"
                >
                  Tipe Kamera
                </label>
                <div className="col-sm-10" style={{ paddingBottom: "10px" }}>
                  <input
                    onChange={handleChange}
                    type="text"
                    name="type"
                    id="type"
                    className="form-control"
                    value={values.type}
                    // validation={{
                    //   touched: touched.type,
                    //   errors: errors.type,
                    // }}
                    validation={''}
                    props={{
                      onBlur: handleBlur,
                    }}
                  />
                  {/* {touched.type && errors.type && (
                    <span style={{ color: "white" }}>{errors.type}</span>
                  )} */}
                </div>

                <label
                  htmlFor="staticEmail"
                  className="col-sm-2 col-form-label"
                >
                  Lokasi Kamera
                </label>
                <div className="col-sm-10" style={{ paddingBottom: "10px" }}>
                  <input
                    onChange={handleChange}
                    type="text"
                    name="location"
                    id="location"
                    className="form-control"
                    value={values.location}
                    validation={''}
                    props={{
                      onBlur: handleBlur,
                    }}
                  />
                  {touched.location && errors.location && (
                    <span style={{ color: "white" }}>{errors.location}</span>
                  )}
                </div>

                <label
                  htmlFor="staticEmail"
                  className="col-sm-2 col-form-label"
                >
                  Lokasi Kamera
                </label>
                <div className="col-sm-10" style={{ paddingBottom: "10px" }}>
                  <SelectInput
                    onChange={(e) => {
                      // console.log(e.target.value)
                      let event = { target: { name: 'siteId', value: e.target.value } }
                        setSite(e.target.value)
                        handleChange(event)
                    }}
                    name="siteId"
                    id="siteId"
                    value={values.siteId}
                    option={optionSites}
                    validation={''}
                    props={{
                      onBlur: handleBlur,
                      helperText: touched.siteId && errors.siteId,
                      error: Boolean(errors.siteId && touched.siteId),
                    }}
                  />
                  {touched.siteId && errors.siteId && (
                    <span>{errors.siteId}</span>
                  )}
                </div>

                <label
                  htmlFor="staticEmail"
                  className="col-sm-2 col-form-label"
                >
                  Latitude
                </label>
                <div className="col-sm-10" style={{ paddingBottom: "10px" }}>
                  <input
                    onChange={handleChange}
                    type="number"
                    name="latitude"
                    id="latitude"
                    className="form-control"
                    value={values.latitude}
                    // validation={{
                    //   touched: touched.latitude,
                    //   errors: errors.latitude,
                    // }}
                    validation={''}
                    props={{
                      onBlur: handleBlur,
                    }}
                  />
                  {/* {touched.latitude && errors.latitude && (
                    <span style={{ color: "white" }}>{errors.latitude}</span>
                  )} */}
                </div>

                <label
                  htmlFor="staticEmail"
                  className="col-sm-2 col-form-label"
                >
                  Longitude
                </label>
                <div className="col-sm-10" style={{ paddingBottom: "10px" }}>
                  <input
                    onChange={handleChange}
                    type="number"
                    name="longitude"
                    id="longitude"
                    className="form-control"
                    value={values.longitude}
                    validation={''}
                    // validation={{
                    //   touched: touched.longitude,
                    //   errors: errors.longitude,
                    // }}
                    props={{
                      onBlur: handleBlur,
                    }}
                  />
                  {/* {touched.longitude && errors.longitude && (
                    <span style={{ color: "white" }}>{errors.longitude}</span>
                  )} */}
                </div>

                <label
                  htmlFor="staticEmail"
                  className="col-sm-2 col-form-label"
                >
                  Altitude
                </label>
                <div className="col-sm-10" style={{ paddingBottom: "10px" }}>
                  <input
                    onChange={handleChange}
                    type="number"
                    name="alt"
                    id="alt"
                    className="form-control"
                    value={values.alt}
                    // validation={{
                    //   touched: touched.alt,
                    //   errors: errors.alt,
                    // }}
                    validation={''}
                    props={{
                      onBlur: handleBlur,
                    }}
                  />
                  {/* {touched.alt && errors.alt && (
                    <span style={{ color: "white" }}>{errors.alt}</span>
                  )} */}
                </div>

                <label
                  htmlFor="staticEmail"
                  className="col-sm-2 col-form-label"
                >
                 Alamat IP
                </label>
                <div className="col-sm-10" style={{ paddingBottom: "10px" }}>
                  <input
                    onChange={handleChange}
                    type="text"
                    name="ip"
                    id="ip"
                    className="form-control"
                    value={values.ip}
                    // validation={{
                    //   touched: touched.ip,
                    //   errors: errors.ip,
                    // }}
                    validation={''}
                    props={{
                      onBlur: handleBlur,
                    }}
                  />
                  {/* {touched.ip && errors.ip && (
                    <span style={{ color: "white" }}>{errors.ip}</span>
                  )} */}
                </div>

                <label
                  htmlFor="staticEmail"
                  className="col-sm-2 col-form-label"
                >
                  Nama Pengguna
                </label>
                <div className="col-sm-10" style={{ paddingBottom: "10px" }}>
                  <input
                    onChange={handleChange}
                    type="text"
                    name="user"
                    id="user"
                    className="form-control"
                    value={values.user}
                    // validation={{
                    //   touched: touched.user,
                    //   errors: errors.user,
                    // }}
                    validation={''}
                    props={{
                      onBlur: handleBlur,
                    }}
                  />
                  {/* {touched.user && errors.user && (
                    <span style={{ color: "white" }}>{errors.user}</span>
                  )} */}
                </div>
                <label
                  htmlFor="staticEmail"
                  className="col-sm-2 col-form-label"
                >
                  Kata Sandi
                </label>
                <div className="col-sm-10" style={{ paddingBottom: "10px" }}>
                  <input
                    onChange={handleChange}
                    type="text"
                    name="password"
                    id="password"
                    className="form-control"
                    value={values.password}
                    // validation={{
                    //   touched: touched.password,
                    //   errors: errors.password,
                    // }}
                    validation={''}
                    props={{
                      onBlur: handleBlur,
                    }}
                  />
                  {/* {touched.password && errors.password && (
                    <span style={{ color: "white" }}>{errors.password}</span>
                  )} */}
                </div>

                <label
                  htmlFor="staticEmail"
                  className="col-sm-2 col-form-label"
                >
                  Url
                </label>
                <div className="col-sm-10" style={{ paddingBottom: "10px" }}>
                  <input
                    onChange={handleChange}
                    type="text"
                    name="url"
                    id="url"
                    className="form-control"
                    value={values.url}
                    validation={''}
                    // validation={''}
                    props={{
                      onBlur: handleBlur,
                    }}
                  />
                  {touched.url && errors.url && (
                    <span style={{ color: "white" }}>{errors.url}</span>
                  )}
                </div>

                <label
                  htmlFor="staticEmail"
                  className="col-sm-2 col-form-label"
                >
                  Alamat MAC
                </label>
                <div className="col-sm-10" style={{ paddingBottom: "10px" }}>
                  <input
                    onChange={handleChange}
                    type="text"
                    name="mac"
                    id="mac"
                    className="form-control"
                    value={values.mac}
                    // validation={{
                    //   touched: touched.mac,
                    //   errors: errors.mac,
                    // }}
                    validation={''}
                    props={{
                      onBlur: handleBlur,
                    }}
                  />
                  {touched.mac && errors.mac && (
                    <span style={{ color: "white" }}>{errors.mac}</span>
                  )}
                </div>

                <label
                  htmlFor="staticEmail"
                  className="col-sm-2 col-form-label"
                >
                  Nomor Seri
                </label>
                <div className="col-sm-10" style={{ paddingBottom: "10px" }}>
                  <input
                    onChange={handleChange}
                    type="text"
                    name="serialNo"
                    id="serialNo"
                    className="form-control"
                    value={values.serialNo}
                    // validation={{
                    //   touched: touched.serialNo,
                    //   errors: errors.serialNo,
                    // }}
                    validation={''}
                    props={{
                      onBlur: handleBlur,
                    }}
                  />
                  {/* {touched.serialNo && errors.serialNo && (
                    <span style={{ color: "white" }}>{errors.serialNo}</span>
                  )} */}
                </div>
              </div>
            </div>
          </form>
        )}
      </Formik>
    </ModalComponent>
  );
};

export default FormCamera;
